module.exports = __webpack_public_path__ + "img/02-title-bar.6713d218.png";